// Modules
import React from "react"

// Styles
import "./MvLink.sass"

export interface Props {
    label: string;
    onClick: () => void;
}

class MvLink extends React.Component<Props> {

    constructor(prop:Props) {
        super(prop)
    }

    render () {
        const { label, onClick } = this.props;
        return (
          <div
            className="mv-link"
            onClick={onClick}
          >
            {label}
          </div>
        )
    }
}

export { MvLink };
